import StandingsTestingBase from "./StandingsTestingBase";

export default function StandingsTestingBrand() {
    return (
        <StandingsTestingBase
            scopeType="BRAND"
            classKey=""
            heading="Meisterschaftswertung"
            pillLabel="MARKE"
        />
    );
}
